var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coins-stacked-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.9166 4.58333C11.9166 5.59586 9.65935 6.41667 6.87492 6.41667C4.09048 6.41667 1.83325 5.59586 1.83325 4.58333M11.9166 4.58333C11.9166 3.57081 9.65935 2.75 6.87492 2.75C4.09048 2.75 1.83325 3.57081 1.83325 4.58333M11.9166 4.58333V5.95833M1.83325 4.58333V15.5833C1.83325 16.5959 4.09048 17.4167 6.87492 17.4167M6.87492 10.0833C6.72042 10.0833 6.56754 10.0808 6.41658 10.0759C3.84694 9.99165 1.83325 9.20634 1.83325 8.25M6.87492 13.75C4.09048 13.75 1.83325 12.9292 1.83325 11.9167M20.1666 10.5417C20.1666 11.5542 17.9094 12.375 15.1249 12.375C12.3405 12.375 10.0833 11.5542 10.0833 10.5417M20.1666 10.5417C20.1666 9.52914 17.9094 8.70833 15.1249 8.70833C12.3405 8.70833 10.0833 9.52914 10.0833 10.5417M20.1666 10.5417V17.4167C20.1666 18.4292 17.9094 19.25 15.1249 19.25C12.3405 19.25 10.0833 18.4292 10.0833 17.4167V10.5417M20.1666 13.9792C20.1666 14.9917 17.9094 15.8125 15.1249 15.8125C12.3405 15.8125 10.0833 14.9917 10.0833 13.9792",
    stroke: "#00E0B4",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.4a6f11eb17f46859f892694cf23e6348.svg";
export { ForwardRef as ReactComponent };